module.exports = __webpack_public_path__ + "static/media/frame_17.19caa993.jpg";